<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div style="display: flex; justify-content: flex-end">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" v-bind="attrs" v-on="on">
                <v-icon>add_circle</v-icon>Add
              </v-btn>
            </template>
            <v-list>
              <v-list-tile @click="onRegister">
                <v-list-tile-content>
                  <v-list-tile-title>ADD NEW</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>

          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="success"
                :loading="buttonLoading"
                v-bind="attrs"
                v-on="on"
                ><v-icon>cloud_download</v-icon>Export</v-btn
              >
            </template>

            <v-list>
              <v-list-tile @click="exportAllProductionPlan()">
                <v-list-tile-content>
                  <v-list-tile-title>EXPORT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>

          <v-btn @click="showFilters = !showFilters" color="#FF4545">
            <v-icon>filter_list</v-icon>Filter
            <v-icon>{{
              showFilters ? "arrow_drop_up" : "arrow_drop_down"
            }}</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12 v-if="showFilters">
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm4>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.fromDate"
                  label="From Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.fromDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm4>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.toDate"
                  label="To Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.toDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm4>
              <v-text-field
                name="issueNo"
                label="Issue No"
                type="text"
                v-model="queryParams.issueNo"
              ></v-text-field>
            </v-flex>
            <v-flex sm4>
              <v-select
                :items="shopList"
                label="Choose Shop"
                v-model="queryParams.shopId"
                item-text="name"
                item-value="id"
                :hide-no-data="true"
                :readonly="checkShopUser() ? true : false"
              ></v-select>
            </v-flex>
            <v-flex sm4>
              <v-select
                :items="warehouseList"
                label="Choose Warehouse"
                v-model="queryParams.warehouseId"
                item-text="name"
                item-value="id"
                :hide-no-data="true"
                :readonly="checkWarehouseUser() ? true : false"
              ></v-select>
            </v-flex>
            <v-flex sm4>
              <v-select
                :items="departmentList"
                label="Choose Department"
                v-model="queryParams.departmentId"
                item-text="name"
                item-value="id"
                :hide-no-data="true"
              ></v-select>
            </v-flex>
            <v-flex sm4>
              <v-text-field
                name="description"
                label="Description"
                type="text"
                v-model="queryParams.description"
              ></v-text-field>
            </v-flex>
            <v-flex sm4>
              <v-select
                :items="statusList"
                label="Choose Status ..."
                v-model="queryParams.status"
                item-text="label"
                item-value="value"
                :hide-no-data="true"
              ></v-select>
            </v-flex>
            <v-flex sm4>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :must-sort="true"
            :headers="headers"
            :items="productionPlanList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
          >
            <template slot="items" slot-scope="props">
              <td>
                <v-btn
                  flat
                  icon
                  color="blue lighten-2"
                  @click="onEdit(props.item)"
                >
                  <v-icon>edit</v-icon>
                </v-btn>
              </td>
              <td>{{ props.item.status }}</td>
              <td>
                {{ props.item.issueDateInMilliSeconds | formatMsDate }}
              </td>
              <td>{{ props.item.issueNo }}</td>
              <td>{{ props.item.shopName }}</td>
              <td>{{ props.item.warehouseName }}</td>
              <td>{{ props.item.departmentName }}</td>
              <td>{{ props.item.description }}</td>
              <td>
                {{ props.item.updatedDateInMilliSeconds | formatMsDateTime }}
              </td>
              <td>{{ props.item.updatedBy }}</td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { productionPlanService } from "../../services/production-plan-service";
import { shopService } from "../../services/shop-service";
import { departmentService } from "../../services/department-service";
import { warehouseService } from "../../services/warehouse-service";
import { commonService } from "../../services/common-service";

export default {
  name: "ProductionPlanList",
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    showListLoading: false,
    buttonLoading: false,
    showFilters: false,
    breadcrumbs: [
      {
        text: "Manufacturing Management",
        disabled: true,
      },
      {
        text: "Production Plan",
        disabled: true,
      },
    ],
    headers: [
      { text: "Action", sortable: false },
      { text: "Status", value: "status" },
      { text: "Issue Date", align: "left", value: "issueDate" },
      { text: "Issue No", align: "left", value: "issueNo" },
      { text: "Shop", align: "left", value: "shop.id" },
      { text: "Warehouse", align: "left", value: "warehouse.id" },
      { text: "Department", align: "left", value: "department.id" },
      { text: "Description", value: "description" },
      { text: "Updated  Date", value: "updatedDate" },
      { text: "Updated  By", value: "updatedBy" },
    ],
    statusList: [
      { label: "---All---", value: "" },
      { label: "DRAFT", value: "DRAFT" },
      { label: "PENDING", value: "PENDING" },
      { label: "CONFIRM", value: "CONFIRM" },
      { label: "CANCEL", value: "CANCEL" },
    ],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "updatedDate",
      totalItems: 0,
    },
    queryParams: {
      fromDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      toDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      issueNo: "",
      shopId: "",
      departmentId: "",
      warehouseId: "",
      description: "",
      status: "",
      isAddDetails: false,
      isAddUnits: false,
    },
    rowsPerPageItems: [25, 50, 100],
    totalRows: 0,
    shopList: [],
    warehouseList: [],
    departmentList: [],
    productionPlanList: [],
  }),
  watch: {
    pagination: {
      handler() {
        this.getProductionPlanList();
      },
      deep: true,
    },
  },
  created() {
    this.queryParams.shopId = this.checkShopUser();
    this.queryParams.warehouseId = this.checkWarehouseUser();

    if (this.$route.query.fromDate) {
      this.queryParams.fromDate = this.$route.query.fromDate;
    }
    if (this.$route.query.toDate) {
      this.queryParams.toDate = this.$route.query.toDate;
    }
    if (this.$route.query.issueNo) {
      this.queryParams.issueNo = this.$route.query.issueNo;
    }
    if (this.$route.query.shopId) {
      this.queryParams.shopId = Number(this.$route.query.shopId);
    }
    if (this.$route.query.departmentId) {
      this.queryParams.departmentId = Number(this.$route.query.departmentId);
    }
    if (this.$route.query.warehouseId) {
      this.queryParams.warehouseId = Number(this.$route.query.warehouseId);
    }
    if (this.$route.query.description) {
      this.queryParams.description = this.$route.query.description;
    }
    if (this.$route.query.status) {
      this.queryParams.status = this.$route.query.status;
    }
    if (this.$route.query.isAddDetails) {
      this.queryParams.isAddDetails = this.$route.query.isAddDetails;
    }
    if (this.$route.query.isAddUnits) {
      this.queryParams.isAddUnits = this.$route.query.isAddUnits;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }

    this.getActiveWarehouseList();
    this.getShopList();
    this.getActiveDepartmentList();
  },
  methods: {
    checkWarehouseUser() {
      if (this.user.role.roleName == "BRANCH_ADMIN") {
        return this.user.warehouseId;
      } else if (this.user.roleName == "PRODUCTION_MANAGER") {
        return this.user.shop.warehouseId;
      } else {
        return "";
      }
    },
    checkShopUser() {
      if (
        this.user.role.roleName == "BRANCH_ADMIN" ||
        this.user.role.roleName == "PRODUCTION_MANAGER"
      ) {
        return this.user.shopId;
      } else {
        return "";
      }
    },
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({
        name: "production-plans",
        query: this.queryParams,
      });
      this.getProductionPlanList();
    },
    getProductionPlanList() {
      this.showListLoading = true;
      this.queryParams.isAddDetails = false;
      let order = this.pagination.descending ? "desc" : "asc";
      productionPlanService
        .getProductionPlanList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.productionPlanList = res.data.productionPlanList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    getShopList() {
      shopService
        .getAllShop()
        .then((res) => {
          this.shopList = res.data;
          this.shopList.unshift({ id: "", name: "---ALL---" });
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getActiveWarehouseList() {
      warehouseService
        .getWarehousesByStatus("ACTIVE")
        .then((res) => {
          this.warehouseList = res.data;
          this.warehouseList.unshift({ id: "", name: "---ALL---" });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getActiveDepartmentList() {
      departmentService
        .getDepartmentsByStatus("ACTIVE")
        .then((res) => {
          this.departmentList = res.data;
          this.departmentList.unshift({ id: "", name: "---All---" });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    exportAllProductionPlan() {
      this.buttonLoading = true;
      this.queryParams.isAddDetails = true;
      productionPlanService
        .getProductionPlanExcelExport(this.queryParams)
        .then((res) => {
          commonService.downloadE(res);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.buttonLoading = false;
        });
    },
    onRegister() {
      this.$router.push("/production-plan/new");
    },
    onEdit(productionPlan) {
      // go to details page
      this.$router.push("/production-plan/" + productionPlan.id);
    },
  },
};
</script>
